import React from 'react'
import messages from './messages'
import Icon from 'components/Icon'
import useApi from 'hooks/useApi'
import OrderRow from 'containers/CustomerOrdersPage/components/OrderRow'
import OrderHeadRow from 'containers/CustomerOrdersPage/components/OrderHeadRow'
import { FormattedMessage } from 'react-intl'
import { Link, useHistory } from 'react-router-dom'

const RecentOrders = () => {
  const history = useHistory()

  const [orders, loadingData, dataErrors, refetchData] = useApi(
    '/rest/v2/order?sortDirection=DESC&sortBy=crdate&pageSize=5&page=0&query='
  )

  if (!orders || !orders.length) {
    return null
  }

  return (
    <div className="hidden sm:block w-full sm:mb-8 lg:mb-10">
      <div class="flex justify-between items-center px-1 mb-4">
        <h1 className="text-xl font-bold">
          <FormattedMessage{...messages.title} />
        </h1>

        <Link to="/orders?sortDirection=DESC&sortBy=crdate&pageSize=50&page=1&query=" className="space-x-2 font-medium text-sm text-primary hover:text-primary-darker">
          <span><FormattedMessage {...messages.showAll} /></span>
          <Icon icon="long-arrow-right" />
        </Link>
      </div>

      <div className="flex flex-col mt-2">
        <div className="align-middle min-w-full overflow-x-auto shadow overflow-hidden sm:rounded-sm">
          <table className="min-w-full divide-y divide-gray-200">
            <thead>
              <OrderHeadRow
                compact
                sortDirection="DESC"
                sortBy="crdate"
                onSort={() => {}}
                columns={[]}
              />
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              { (orders || []).map((order) => (
                <OrderRow
                  compact
                  order={order}
                  columns={[]}
                  onClick={() => history.push(`/orders?id=${order.uid}&query=${order.uid}`)}
                  isSelected={false}
                />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default RecentOrders
